// extracted by mini-css-extract-plugin
module.exports = {"image":"ProfileImage_image__2Nevc"};